import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hourFormat12',
    standalone: true
})
export class HourFormat12Pipe implements PipeTransform {
    transform = hourFormat12;
}

export function hourFormat12(input: string, separator = ' ') {
    if (typeof input !== 'string') {
        return input;
    }
    // Check correct time format and split into components
    const time = input.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/);

    if (!time || !(time.length > 1)) {
        // If time format correct
        return input;
    }
    const parts = time.slice(1); // Remove full string match value
    const hour = parseInt(parts[0], 10);
    parts[5] = hour < 12 ? `${separator}am` : `${separator}pm`; // Set AM/PM
    parts[0] = (hour % 12 || 12) + ''; // Adjust hours

    return parts.join(''); // return adjusted time or original string
}
